/* global globalThis */
import trace from '~/lib/trace';
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import sy from '~/styles';
import {Link} from '~/components/controls';
import {
  service_request as serviceRequestApi,
  rob as robApi,
  fleet as fleetApi,
} from '~/api/private';

const PdfViewerLink = ({invoice, request_id, is_fleet_car}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      let pdf;
      if (invoice?.bahnkick_can_invoice) {
        if (is_fleet_car) {
          pdf = await fleetApi.invoice_pdf(request_id);
        } else {
          pdf = await robApi.invoice_pdf(request_id);
        }
      } else {
        pdf = await serviceRequestApi.invoice_pdf(request_id);
      }

      setData(pdf);
    };

    fetch().catch(trace);
  }, [invoice, request_id, is_fleet_car]);

  return (
    <Link
      style={sy.underline}
      onPress={() => {
        const obj = URL.createObjectURL(data);
        const iframe = `<div onclick="window.close();" style='position: absolute;background-color: #fff; padding: 4px;'><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg></div><iframe width='100%' height='100%' src="${obj}"></iframe>`;
        const openWindow = globalThis.window?.open ?? globalThis.open;
        const x = openWindow?.();
        if (!x) {
          return;
        }

        const targetBody = x.document?.body ?? {innerHTML: ''};
        targetBody.innerHTML = iframe;

        if (!x.document?.body && x.document) {
          x.document.body = targetBody;
        }
      }}>
      Bekijk factuur (PDF)
    </Link>
  );
};
PdfViewerLink.propTypes = {
  invoice: PropTypes.any,
  request_id: PropTypes.any,
  is_fleet_car: PropTypes.any,
};

export default PdfViewerLink;
